module.exports = __webpack_public_path__ + "img/PCT14.838ad32f.svg";